import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './Start.st.css.js';
class Start extends React.PureComponent {
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.start }, children);
    }
}
Start.propTypes = {
    children: PropTypes.node,
};
export default Start;
//# sourceMappingURL=Start.js.map